import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset1_PD: string = `
CASE WHEN bestrank.rank is not null then 2 else 1 END as rank,
id,
label,
attributes
`;

export const order_ruleset1_PD  = 'bestrank.rank is not null DESC, label';

const getAttributes = (rawName: string) => ({
    dn: `$.15.${rawName}`,
    kvs: `$.14.${rawName}`,
    kvsls: `$.3460.${rawName}`,
    dpmax: `$.28.${rawName}`,
    line: `$.6667.${rawName}`
});

export const buildQuery_ruleset1_PD: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    kvs,
    minDN,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(ifnull(kvsAttr.value, cast(kvslsAttr.value as float) * 3.6) as float) as kvs,
                       cast(dnAttr.value as float) as DN,
                       coalesce(lineAttr.value, 'empty') as line,
                       cast(dpmaxAttr.value as float) as dpmax,
                       CASE
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Characterised control valve"%' THEN 2.5
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Potable water valve"%' THEN 2.5
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Butterfly valve"%' THEN 4
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Globe valve"%' THEN 2.2   
                           ELSE 0    
                       END as maxVelocity,
                       CASE
                           WHEN ${extractJsonFieldSql('attributes', `$.6667.${rawName}`)} like '%"CCV"%' THEN 2.5
                           WHEN ${extractJsonFieldSql('attributes', `$.6667.${rawName}`)} like '%"BFV"%' THEN 2.5
                           WHEN ${extractJsonFieldSql('attributes', `$.6667.${rawName}`)} like '%"GV"%' THEN 2.5  
                           ELSE 1.2    
                       END as upperCoeff,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvs}`)}) as kvsAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvsls}`)}) as kvslsAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dn}`)}) as dnAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.line}`)}) as lineAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
                    WHERE ${filter})
            , user_input as (SELECT cast(? as float) as v100, cast(? as float) as kvs, cast(? as float) as minDN)
            , bounds as (SELECT
                             cast(floor(kvs * 0.6 * 10) as float) / 10 as lower,
                             v100,
                             kvs,
                             minDN
                         FROM user_input)
            , data as (SELECT 
                           abs(bounds.kvs - products_filtered.kvs) as rank,
                           line,
                           products_filtered.kvs as kvs,
                           DN,
                           maxVelocity,
                           id,
                           label,
                           attributes
                       FROM products_filtered
                       JOIN bounds
                       WHERE products_filtered.kvs between bounds.lower and round(bounds.kvs * products_filtered.upperCoeff, 1)
                         AND CASE WHEN bounds.v100 > 0 AND  dpmax > 0 THEN 100 * pow(bounds.v100 / products_filtered.kvs, 2) <= dpmax
                             ELSE true END
                         AND CASE WHEN DN > 0 AND bounds.v100 > 0 AND products_filtered.maxVelocity > 0 THEN
                             bounds.v100 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= products_filtered.maxVelocity
                             ELSE true END
                         AND CASE WHEN bounds.minDN > 0 AND DN > 0 THEN DN >= bounds.minDN
                             ELSE true END
                       ORDER BY DN, label)
            , bestrank as (SELECT min(rank) as rank, line FROM data GROUP BY line)
         SELECT ${selectFields}
         FROM data
         LEFT JOIN bestrank ON bestrank.rank = data.rank AND bestrank.line = data.line
        `,
        [volumetricFlow, kvs, minDN]
    ];
}



